import { Mixpanel } from '../../common/mixpanel';
import { IAppState } from '../types';

export const getMixpanel = (state: IAppState): Mixpanel | undefined =>
  state.mixpanel.instance;
